import { SxProps, Theme } from '@mui/material/styles';

const styles: SxProps<Theme> = [
  {
    padding: '1.25rem 0',
  },
];

export default styles;
